import { render, staticRenderFns } from "./BridgeHistories.vue?vue&type=template&id=96d7bc04&"
import script from "./BridgeHistories.vue?vue&type=script&lang=js&"
export * from "./BridgeHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports